import React, { useEffect, useState } from "react"

import "./ListOfSales.css"
import "../../Components/Commons/Commons.css"

import SidebarMenu from "../../Components/Sidebar/Sidebar"
import AntDTable from "../../Components/AntDTable/AntDTable"
import BtnDelete from "../../Components/Commons/Buttons/BtnDelete"
import DeleteModal from "../../Components/Modals/DeleteModal"
import AddItem from "./AddItem"
import EditItem from "./EditItem"

import { Col, Row } from "react-bootstrap"
import { getInventories } from "../../Components/Helpers/API/InventoryApi/InventoryApi"
import { deleteItem } from "../../Components/Helpers/API/PharmacyApi/PharmacyApi"
import { toast } from "react-toastify"
import { formatPrice } from "../../Components/Helpers/Utilities/Common"

function Inventories() {
  const [data, setData] = useState([])
  const [showDelete, setShowDelete] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [selectedRow, setSelectedRow] = useState({})

  // function for adding button in the table
  function ActionBtn(row) {
    return (
      <>
        <Row className="center">
          <Col>
            <EditItem refetch={fetchInventories} initialValues={row.row} />
          </Col>
          <Col>
            <BtnDelete
              outline
              label={"Delete"}
              size={"sm"}
              onClick={(e) => {
                setShowDelete(true)
                setSelectedRow(row.row)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }

  // Function get inventories API
  async function fetchInventories() {
    setShowLoader(true)
    const res = await getInventories()

    if (res.data) {
      var _parsed = res.data.data.map((inventory) => ({
        ...inventory,
        value: inventory.id,
        label: inventory.item,
        stock: formatPrice(inventory.stock),
      }))
      setData(_parsed)
    }
    setShowLoader(false)
  }

  //Function delete invetories API
  const handleDelete = async () => {
    const res = await deleteItem(selectedRow.id)
    if (res.data) {
      toast.success(res.data.message)
      setShowDelete(false)
      setSelectedRow({})
      fetchInventories()
    } else if (res.error) {
      toast.error(res.error)
    }
  }

  useEffect(() => {
    fetchInventories()
  }, [])

  return (
    <div className="App">
      <SidebarMenu active={"Pharmacy"} active_sub={"Inventories"} />
      <div className="col p-5 pt-4 manager-container all-container">
        <div className="row pt-2 p-3">
          <div className="col-10 font-big title-2 all-patient">
            Inventories
          </div>
          <div className="col-2 font-big font-bold">
            <AddItem refetch={fetchInventories} />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-sm-12 all-table">
            <AntDTable
              tableHeaders={["ITEM", "DESCRIPTION", "UNIT PRICE", "STOCK"]}
              headerSelector={["item", "description", "unit_price", "stock"]}
              tableData={data}
              ActionBtn={(row) => ActionBtn(row)}
              loading={showLoader}
              withAction={true}
            />
          </div>
        </div>
      </div>
      <DeleteModal
        title={`Do you want to delete this item?`}
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={handleDelete}
      />
    </div>
  )
}

export default Inventories
